import { Location } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { iconsLibrary } from "../../../theme/constants";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { EActiveTab } from "../../data-types/tabs.enum";
import { CoworkerService } from "../../services/coworker.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import * as moment from "moment";
import { StateService } from "../../services/state.service";

@Component({
  selector: "cowing-core-coworker-booking",
  templateUrl: "./coworker-booking.component.html",
  styleUrls: ["./coworker-booking.component.scss"],
})
export class CoworkerBookingComponent implements OnInit {
  @Input("coworkingId") coworkingId = null;
  private tokenRefreshed = false;
  private bookingToDelete;
  public show24CancelMessage = false;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;
  public EActiveTab = EActiveTab;
  public bookingList = [];
  public bookingListPast = [];
  public bookingListAfter = [];
  public bookingStates = [];
  public showCancelBookingSection = false;
  constructor(
    private _store: Store<IAppState>,
    private _router: Router,
    private translate: TranslateService
  ) {}
  async ngOnInit() {
    this._store.dispatch(showLoadingAction({}));
    const coworkerId = LocalStorageService.instance.get(EStorageType.Coworker);
    try {
      const bookingStates = await StateService.instance.getStates(1);
      this.bookingStates = bookingStates;
      const response = await CoworkerService.instance.getCoworkerBookings(
        coworkerId
      );
      this.bookingList = response;

      this.bookingListPast = response.filter((booking) => {
        return moment(booking.start_date, "DD/MM/YYYY").isBefore(moment());
      });
      this.bookingListAfter = response.filter((booking) => {
        return moment(booking.start_date, "DD/MM/YYYY").isSameOrAfter(moment());
      });
    } catch (e) {
      if (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      }
      
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get getCalendarIcon() {
    return `${iconsLibrary.calendarEmpty}`;
  }

  private get getCancelStatus() {
    const cancelStatus = this.bookingStates.find((state, i) => {
      return state.id === 6;
    }).id;
    return cancelStatus;
  }
  public get getClose() {
    return `${iconsLibrary.closeSimple}`;
  }

  showCancel24msg(booking) {
    let finishDate = moment(booking.start_date, "DD/MM/YYYY");
    finishDate.hours(booking.start_time.split(":")[0]);
    finishDate.minutes(booking.start_time.split(":")[1]);
    return (
      booking.state_id !== 3 && moment(finishDate).diff(moment(), "days") < 1
    );
  }

  showCancel(event?) {
    this.show24CancelMessage = false;
    this.showCancelBookingSection = !this.showCancelBookingSection;
    if (event) {
      this.bookingToDelete = event;
      let booking = this.bookingList.find((elem) => {
        return elem.id === event;
      });
      if (booking) {
        if (this.showCancel24msg(booking)) {
          this.show24CancelMessage = true;
        }
      }
    } else {
      this.bookingToDelete = null;
    }
  }
  public async cancelBooking() {
    this._store.dispatch(showLoadingAction({}));
    try {
      const changeBooking = await CoworkerService.instance.changeBookingStatus(
        this.bookingToDelete,
        this.getCancelStatus
      );
      this._router.navigate(["cancel-confirmation"]);
    } catch (e) {
      if (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      }
      
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
}
